/**
 * Confetti / Particles
 * All Steps are marked up using 'article',
 */
import $ from 'jquery';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Confetti / Particles
         */
        console.log( 'Confetti / Particles - init' );

    },
    
    triggerParticles( targ ) {
        
        /*
         * CONFETTI ANIMATION
         */
        var d = document, $d = $(d),
            w = window, $w = $(w),
            wWidth = $w.width(), wHeight = $w.height(),
            particles = $('.progress_complete'),
            particleCount = 0,
            sizes = [
              15, 20, 25, 35, 45
            ],
            /*colors = [
              '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5',
              '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4CAF50',
              '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800',
              '#FF5722', '#795548', '#9E9E9E', '#607D8B', '#777777'
            ],*/

            classes = [
                'tint1', 'tint2', 'tint3', 'tint4', 'tint5'
            ],

            mouseX = $w.width() / 2, mouseY = $w.height() / 2;


        function createParticle( particle_target, particle_type ) {
            var particle = $('<div class="confetti particle ' + particle_type + '"/>'),
            size = sizes[Math.floor(Math.random() * sizes.length)],
            //color = colors[Math.floor(Math.random() * colors.length)],
            colorclass = classes[Math.floor(Math.random() * classes.length)],
            negative = size/2,
            speedHorz = Math.random() * 10,
            speedUp = Math.random() * 25,
            spinVal = 360 * Math.random(),
            spinSpeed = ((36 * Math.random())) * (Math.random() <=.5 ? -1 : 1),
            otime,
            time = otime = (1 + (.5 * Math.random())) * 1000,
            top = (particles.height() / 2),
            left = (particles.width() / 2),

            direction = Math.random() <=.5 ? -1 : 1 ,
            life = 10;
            //console.log( 'top: ' + top );
            //console.log('colorclass: ' + colorclass);
            /*if ( particle_type == 'ctriangle' ) {
                //var b64tri = btoa('<svg xmlns="http://www.w3.org/2000/svg" width="30.66" height="25.19" viewBox="0 0 30.66 25.19"><path d="M15.33,25.19H2a2,2,0,0,1-1.72-3.1L13.62,1a2,2,0,0,1,3.43,0l13.3,21.14a2,2,0,0,1-1.72,3.1Z" style="fill: ' + color + '"/></svg>');
                var b64tri = btoa('<svg xmlns="http://www.w3.org/2000/svg" width="30.66" height="25.19" viewBox="0 0 30.66 25.19"><path d="M15.33,25.19H2a2,2,0,0,1-1.72-3.1L13.62,1a2,2,0,0,1,3.43,0l13.3,21.14a2,2,0,0,1-1.72,3.1Z" class="' + colorclass + '"/></svg>');
                var triangle = "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMC42NiIgaGVpZ2h0PSIyNS4xOSIgdmlld0JveD0iMCAwIDMwLjY2IDI1LjE5Ij48cGF0aCBkPSJNMTUuMzMsMjUuMTlIMmEyLDIsMCwwLDEtMS43Mi0zLjFMMTMuNjIsMWEyLDIsMCwwLDEsMy40MywwbDEzLjMsMjEuMTRhMiwyLDAsMCwxLTEuNzIsMy4xWiIgc3R5bGU9ImZpbGw6ICM2NjYiLz48L3N2Zz4=')";
                //color = 'transparent';

            } else {
                var triangle = '';
                particle.addClass(colorclass);
            }*/

            particle.addClass(colorclass);

            particle.css( {
                height: size + 'px',
                width: size + 'px',
                top: top + 'px',
                left: left + 'px',
                //backgroundColor: color,
                //backgroundImage: triangle,
                backgroundSize: size,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                transform: 'rotate(' + spinVal + 'deg)',
                webkitTransform: 'rotate(' + spinVal + 'deg)'
            }).appendTo( particle_target );

            var particleTimer = setInterval(function () {
                time = time - life;
                left = left - (speedHorz * direction);
                top = top - speedUp;
                speedUp = Math.min(size, speedUp - 1);
                spinVal = spinVal + spinSpeed;


                particle.css({
                    height: size + 'px',
                    width: size + 'px',
                    top: top + 'px',
                    left: left + 'px',
                    opacity: ((time / otime)/2) + .25,
                    transform: 'rotate(' + spinVal + 'deg)',
                    webkitTransform: 'rotate(' + spinVal + 'deg)'
                });

                if( time <= 0 || left <= -size || left >= wWidth + size || top >= wHeight + size ) {
                    particle.remove();
                    clearInterval(particleTimer);
                }
            }, 1000 / 60);  
        }
        
        function particlesStart( targ ) {
            //if ( $( this ).hasClass( 'progress_complete') ) {
                doParticles( targ, 9 );
                setTimeout( function(){
                    doParticles( targ, 9 );
                }, 500 );
                setTimeout( function(){
                    doParticles( targ, 9 );
                }, 1000 );
                setTimeout( function(){
                    doParticles( targ, 9 );
                }, 1500 );
            //}
        }
        particlesStart( targ );
        
        function doParticles( targ, num ) {
            for (var i = 0; i < num; i++) {
                if ( i == 1 || i == 4 || i == 7 ) {
                    var particle_type = 'csquare';
                } else if ( i == 2 || i == 5 || i == 8 ) {
                    var particle_type = 'cround';
                } else if ( i == 3 || i == 6 || i == 9 ) {
                    var particle_type = 'ctriangle';
                }
                createParticle( targ, particle_type );
            }

        }
    }
  
}